import * as actionTypes from "../types";
import * as firebase from "../../utils/firebase";
import { onSnapshot } from "firebase/firestore";



export const addRequest = (bookID, dateReserved, duration) => async (dispatch) => {
    try {
        const added = firebase.addRequest(bookID, dateReserved, duration);
        if (added) {
            dispatch({
                type: actionTypes.ADD_REQUEST,
                payload: true
            });
        } else {
            console.log("false")
        }
    } catch (err) {
        console.error(err);
    }
};

export const getRequests = () => async (dispatch) => {
    try {
        onSnapshot(firebase.getRequests(), request => {
            var requests = [];
            var books = []
            request.forEach((doc) => {
                requests.unshift({ ...doc.data(), id: doc.id })
                books.push(doc.data().bookBorrowed)
            });
            if (requests.length > 0) {
                dispatch({
                    type: actionTypes.GET_REQUEST,
                    payload: {
                        requests: requests,
                        requestEmpty: false,
                        bookID: books
                    }
                });
            } else {
                dispatch({
                    type: actionTypes.GET_REQUEST,
                    payload: {
                        requests: requests,
                        requestEmpty: true,
                        bookID: books
                    }
                });
            }
        })
    } catch (err) {
        console.error(err);
    }
}

export const getRequestBooks = (bookArray) => async (dispatch) => {
    try {
        if (bookArray.length > 0) {
            onSnapshot(firebase.getBooks(), request => {
                var books = [];
                request.forEach((doc) => {
                    for(var x=0; x<bookArray.length; x++){
                        if(bookArray[x] === doc.data().bookID) books.push({ ...doc.data(), id: doc.id })
                    }
                });
                if (books.length > 0) {
                    dispatch({
                        type: actionTypes.GET_REQUEST_BOOKS,
                        payload: {
                            borrowedBooks: books,
                            borrowedBooksEmpty: false
                        }
                    });
                } else {
                    dispatch({
                        type: actionTypes.GET_REQUEST_BOOKS,
                        payload: {
                            borrowedBooks: books,
                            borrowedBooksEmpty: true
                        }
                    });
                }
            })
        }
    } catch (err) {
        console.error(err);
    }
}
